import { FC } from "react"

export const MenuItem:FC<any> = (props):JSX.Element => {

    const { redirect, classname, Component, Component2,  title , visible } = props
    return (
        <div onClick={redirect} className={classname} style={visible? {} : {display:'none'}}>
            {Component}
            <span>{title}</span>
            {Component2}
        </div>

    )
}